import userService from 'resources/user/user.service';
import dealService from 'resources/deal/deal.service';

import * as userHelpers from 'resources/user/user.helpers';

export const getRealtorClients = async (realtorId, companyId, excludeDeals = false) => {
  const clients = await userService.getRealtorClients(realtorId) || [];
  const realtorDeals = await dealService.getDealsByRealtorId(realtorId) || [];

  const filteredClients = userHelpers.filterSampleClients({
    clients,
    realtorId,
    deals: realtorDeals,
  });

  if (excludeDeals) {
    return filteredClients;
  }

  const filteredClientIds = filteredClients.map(({ id }) => id);

  const deals = await dealService.getDealsByClientIds(filteredClientIds, companyId);
  const clientsWithDeals = filteredClients.map((client) => {
    const clientDeals = deals.filter((deal) => deal.client_ids.includes(client.id));

    return { ...client, deals: clientDeals };
  });

  return clientsWithDeals;
};
